"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
class HttpClient {
    constructor(baseURL = '/api', gridClientID = null) {
        this.cancel = (message) => {
            this.cancelTokenSource.cancel(message || 'Request was canceled');
        };
        this._initializeResponseInterceptor = () => {
            this.instance.interceptors.response.use(this._handleResponse);
        };
        this._handleResponse = ({ data }) => data;
        this.cancelTokenSource = axios_1.default.CancelToken.source();
        this.instance = axios_1.default.create({
            baseURL,
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Grid-Client-Id': gridClientID,
            },
            cancelToken: this.cancelTokenSource.token,
        });
        this._initializeResponseInterceptor();
    }
}
exports.default = HttpClient;
